var _GD = _GD || {};

if (typeof console == "undefined")
    var console = {
        log: function() {}
    };


_GD.is_touch_device = function() {
    //        return !!('ontouchstart' in window);
    return /(iphone|ipod|ipad|android|iemobile|blackberry|bada)/.test(window.navigator.userAgent.toLowerCase());
};

_GD.is_touch = _GD.is_touch_device();
_GD.ie11 = !!window.MSInputMethodContext && !!document.documentMode;
_GD.is_mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;


if (_GD.is_touch) { // remove all :hover stylesheets
    try { // prevent exception on browsers not supporting DOM styleSheets properly
        // for (var si in document.styleSheets) {
        //     var styleSheet = document.styleSheets[si];
        //     if (!styleSheet.rules) continue;

        //     for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
        //         if (!styleSheet.rules[ri].selectorText) continue;

        //         if (styleSheet.rules[ri].selectorText.match(':hover')) {
        //             styleSheet.deleteRule(ri);
        //         }
        //     }
        // }
    } catch (ex) {}

}








/*
 ######  ##     ##  ######
##    ## ##     ## ##    ##
##       ##     ## ##
 ######  ##     ## ##   ####
      ##  ##   ##  ##    ##
##    ##   ## ##   ##    ##
 ######     ###     ######
*/


_GD.svgReplace = function(){
    $('img.svg, svg.svg use').addClass('invisible').each(function () {
      var $img = $(this);
      var $svg, imgName;
      var imgURL = $img.attr('src');
      if (!imgURL) {
        imgURL = $img.attr('xlink:href');
        imgName = imgURL.replace(/#icon-/, '');
      } else {
        imgName = imgURL.replace(/\.svg\?.+/, '').substring(imgURL.lastIndexOf('/')+1);
      }
      $svg = $('#icon-'+imgName).clone();
      // $svg = $('<svg><use xlink:href="#icon-'+imgName+'"></use></svg>');
      if ($img.parents('.svg').length) {
        $img = $img.parents('.svg');
      }

      var attributes = $img.prop("attributes");
      $.each(attributes, function() {
        if (this.name != 'src') {
          $svg.attr(this.name, this.value);
        }
      });

      $img.replaceWith($svg);
      $svg.removeClass('invisible');
      $svg.css({ 'visibility': 'visible' });

    });
  }

  ;
  (function (window, document) {
    'use strict';

    var file = '/t/dk/svg/icons-defs.svg',
    // var file = '/t/dk/svg/icons-symbol.svg',
      revision = 1.8;

    if (!document.createElementNS || !document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect)
      return true;

    var isLocalStorage = 'localStorage' in window && window['localStorage'] !== null,
      request,
      data,
      insertIT = function () {
        document.body.insertAdjacentHTML('afterbegin', data);
      },
      insert = function () {
        if (document.body) insertIT();
        else document.addEventListener('DOMContentLoaded', insertIT);
        _GD.svgReplace();
      };

    if (isLocalStorage && localStorage.getItem('inlineSVGrev') == revision) {
      data = localStorage.getItem('inlineSVGdata');
      if (data) {
        insert();
        return true;
      }
    }

    try {
      request = new XMLHttpRequest();
      request.open('GET', file, true);
      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          data = request.responseText;
          insert();
          if (isLocalStorage) {
            localStorage.setItem('inlineSVGdata', data);
            localStorage.setItem('inlineSVGrev', revision);
          }
        }
      }
      request.send();
    } catch (e) {}

  }(window, document));

// _GD.svgs = {};
// _GD.svgtoPathHelper = function($svg, imgURL) {
// 	var $_img = $('img[src^="'+imgURL+'"]');
// 		$_img.each(function(index, el) {
// 			var $_svg = $svg.clone();
// 			$(el).replaceWith($_svg);
// 			$_svg.removeClass('invisible');
// 			$_svg.css({ 'visibility': 'visible' });
// 		});
// }
_GD.svgtoPath = function() {
    _GD.svgReplace();
    // if ($('#debug').length) {
    //     return;
    // } else {
    //     // $('img[src$=".svg"]').addClass('invisible').each(function() {
    //     $('img.svg').addClass('invisible').each(function() {
    //         var $img = $(this);
    //         var imgURL = $img.attr('src');
    //             imgURL = imgURL.replace(/\?.+/,'');
    //         var attributes = $img.prop("attributes");
    //         var $svg;
    //         if (!_GD.svgs[imgURL]) {
    //             _GD.svgs[imgURL] = {};
    //             $.get(imgURL, function(data) {
    //                 // Get the SVG tag, ignore the rest
    //                 $svg = $(data).find('svg');
    //                 // Remove any invalidT5'';,M;LMNMKK N,M XML tags
    //                 $svg = $svg.removeAttr('xmlns:a');
    //                 // Loop through IMG attributes and apply on SVG
    //                 $.each(attributes, function() {
    //                     $svg.attr(this.name, this.value);
    //                 });
    //                 _GD.svgs[imgURL] = $svg;
    //                 // Replace IMG with SVG
    //                 _GD.svgtoPathHelper($svg, imgURL);
    //             }, 'xml');
    //         } else {
    //             $svg = _GD.svgs[imgURL];
    //             if ($svg.length){
    //                 // дубль
    //                 _GD.svgtoPathHelper($svg, imgURL);
    //             }
    //         }
    //     });
    // }
};





$(document).ready(function() {


/*

    ##     ## ########    ###    ########  ########   #######   #######  ##     ##
    ##     ## ##         ## ##   ##     ## ##     ## ##     ## ##     ## ###   ###
    ##     ## ##        ##   ##  ##     ## ##     ## ##     ## ##     ## #### ####
    ######### ######   ##     ## ##     ## ########  ##     ## ##     ## ## ### ##
    ##     ## ##       ######### ##     ## ##   ##   ##     ## ##     ## ##     ##
    ##     ## ##       ##     ## ##     ## ##    ##  ##     ## ##     ## ##     ##
    ##     ## ######## ##     ## ########  ##
    ##  #######   #######  ##     ##

*/

    _GD.$top = $('header');
    _GD.$top.headroom({
        "offset": 50
    });

    // https://tympanus.net/codrops/2014/07/10/inspiration-for-custom-select-elements/
    // [].slice.call( document.querySelectorAll( '.cs-select select' ) ).forEach( function(el) {
    //     new SelectFx(el);
    // } );

    $('#tothetop').on('click', function (e) {
        e.preventDefault();
        // $('html, body').scrollTop(0);
        $('html, body').animate({
           'scrollTop':   0
       }, 500);
    });

    if ($('select').length){
        // $.each($('select:not([multiple])'),function() {
        // setTimeout(function () {
            $.each($('select'),function() {
                var el = $(this);
                el.select2({
                    theme: "dk",
                    width: "100%",
                    placeholder: el.attr('placeholder')||'…',
                    minimumResultsForSearch: -1
                })
                // .on("select2:select select2:unselect", function (e) {
                //     // el[0].dispatchEvent(new Event('change', { 'bubbles': true }))
                //     el[0].dispatchEvent(new Event('change'))
                // })
                ;
            });
        // }, 0);

        // $.each($('select[multiple]'),function() {
        //     var el = $(this);
        //     el.select2({
        //         theme: "dkm",
        //         width: "100%",
        //         placeholder: el.attr('placeholder')||'…',
        //         minimumResultsForSearch: -1
        //     });
        //     el.on('select2:opening select2:closing', function( event ) {
        //         var $searchfield = $(this).parent().find('.select2-search__field');
        //         $searchfield.prop('disabled', true);
        //     });
        // });

        // $('#additional').hide();
    }

    $(document).foundation();


    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
      // newSize is the name of the now-current breakpoint, oldSize is the previous breakpoint
    //   console.log("newSize", newSize);
    });




    _GD.$top = $('body>header, #tothetop');
    $(window).on('scroll', function(e){
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > 0 && !_GD.$top.hasClass('scrolled')) {
            _GD.$top.addClass('scrolled');
        }
        if (scrollTop <= 0){
            _GD.$top.removeClass('scrolled');
        }

    }).trigger('scroll');




    $('.catalog nav a').on('mouseenter', function () {
        var target = $(this).attr('rel');
        console.log("target", target);
        $('.catalog .visual div').css({'z-index':0, 'opacity':0});
        $('.catalog .visual #' + target +'_visual').css({'z-index':1, 'opacity':1});
    });

    $(".slick-partners").slick({
            // normal options...
            // infinite: false,
            slidesToShow: 5,
            rows: 0,
            slidesToScroll: 1,
            // the magic
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 2,
                        infinite: true
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: false
                    }
                },{
                    breakpoint: 479,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false
                    }
                },
            ]
        });

    $(".blog-slick").slick({

        // normal options...
        // infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        rows: 0,
        // the magic
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true
                }
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                }
            },
            // {
            //     breakpoint: 400,
            //     settings: "unslick" // destroys slick
            // }
        ]
    });

    $(".reviews-slick").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 0,
        rows: 0,
        adaptiveHeight: true,
        fade: true,
        cssEase: 'linear',
        prevArrow: $('.__slick-prev'),
        nextArrow: $('.__slick-next'),
    });

    // _GD.svgtoPath();




    _GD.plrl = function(number, one, two, five) {
        var n = Math.abs(number);
        n %= 100;
        if (n >= 5 && n <= 20) {
          return five;
        }
        n %= 10;
        if (n === 1) {
          return one;
        }
        if (n >= 2 && n <= 4) {
          return two;
        }
        return five;
      }










/*
   ###    ##     ## ########  #######  ##    ## ##     ## ##     ##
  ## ##   ##     ##    ##    ##     ## ###   ## ##     ## ###   ###
 ##   ##  ##     ##    ##    ##     ## ####  ## ##     ## #### ####
##     ## ##     ##    ##    ##     ## ## ## ## ##     ## ## ### ##
######### ##     ##    ##    ##     ## ##  #### ##     ## ##     ##
##     ## ##     ##    ##    ##     ## ##   ### ##     ## ##     ##
##     ##  #######     ##     #######  ##    ##  #######  ##     ##
*/

      _GD.autoNum = function (id) {
          var idNum = id+'Num';
          var input = $('#'+id);
          var slider = $('[aria-controls='+id+']').parents('.slider');
          // var input2 = ($('#'+idNum).length) ? $('#'+idNum) : $('<input id="'+idNum+'" type="text" />');
          var input2 = $('<input id="'+idNum+'" type="text" />');
          if($('#'+idNum).length){
              $('#'+idNum).detach();
          }
          input.before(input2);
          // input.mask('000.000.000.000.000,00', {reverse: true});
          input2.mask("# ##0", {reverse: true});
          input2.on("blur", function(e) {
              var val = this.value.replace(/ /g,'');
              // console.log(val);
              if (!e.isTrigger) {
                  input.val(val).trigger('change');
              }
          });
          input.hide();
          // input.next('.slider').on("moved.zf.slider", function(e,b) {
          slider.on("moved.zf.slider", function(e,b) {
              var val = input.val();
              input2.val(val).trigger('input');
          });
      }





/*
########    ###    ########   ######
   ##      ## ##   ##     ## ##    ##
   ##     ##   ##  ##     ## ##
   ##    ##     ## ########   ######
   ##    ######### ##     ##       ##
   ##    ##     ## ##     ## ##    ##
   ##    ##     ## ########   ######
*/


      _GD.tabsToSelect__Data = {};
      _GD.tabsToSelect = function ($deskid, $mobid) {

          var indx = $deskid.attr('id');
          var selectName = $deskid.attr('rel') ? $deskid.attr('rel') : 'relType';
          _GD.tabsToSelect__Data[indx] = {};
          var __c = _GD.tabsToSelect__Data[indx];

          $deskid.on('change.zf.tabs', function(event, el){
              var $el = $(el).find('a');
            //   var target = $el.attr('data-tabs-target');
              var val = $el.text();
              __c.typesSelect.val(val).trigger('change');
          });

          if(! __c.types){

               __c.types = [
                  // {
                  //     id: -1,
                  //     text: '',
                  //     selected: 'selected',
                  //     search:'',
                  //     hidden:true
                  // }
              ];
              $('.tabs-title a', $deskid).each(function(i,el) {
                  var $el = $(el);
                //    __c.types.push({'id': $el.attr('data-tabs-target'),'text':$el.text()});
                   __c.types.push({'id': $el.text(),'text':$el.text()});
              });

              var select2Opts = {
                  // placeholder: {
                  //     id: "-1",
                  //     text: "Выберите тип недвижимости",
                  //     selected:'selected'
                  // },
                  // allowClear:true,
                //   data:  __c.types,
                  theme: "dkt",
                  width: "100%",
                  minimumResultsForSearch: -1
              };

              __c.typesSelect = $("select", $mobid);

              if ( !__c.typesSelect.length ) {
                   $mobid.append($('<select name="'+selectName+'" />'));
                   __c.typesSelect = $("select", $mobid);
                   select2Opts.data = __c.types;
              }

              // console.log("select2Opts", select2Opts);

               __c.typesSelect.select2(select2Opts);

               $(window).on('resize', function() {
                 __c.typesSelect.select2("close");
               });

               // is-active
               if ($deskid.find('.is-active').length) {
                   var current = $deskid.find('.is-active').text();
                   // console.log("current", current);
                   __c.typesSelect.val(current).trigger('change');
               }


              __c.typesSelect.on('select2:select', function (e) {
                  var data = e.params.data;
                //   var $target = $('#'+data.id);
                  var $atarget = $(".tabs-title a:contains("+data.id+")", $deskid);

                $(".tabs-title a", $deskid).each(function(index, el) {
                    var t = $(el).text();
                    if (data.id == t) {
                        $atarget = $(el);
                        return;
                    }
                });

                  if ($atarget.length) {
                      var $target =  $('#'+$atarget.attr('data-tabs-target'));
                      var historyHandled = false;

                      if ($target.length /*&& $("*[data-tabs-content="+$target+"]")*/) {
                          $deskid.foundation('selectTab', $target, historyHandled);
                      } else {
                          //   var href = $('.tabs-title a[data-tabs-target='+data.id+']', $deskid).attr('href');
                          var href = $atarget.attr('href');
                          window.location = href;
                      }
                  }
              });
          }

      }

      if ($('#deskTabsToSelect').length) {
          _GD.tabsToSelect($('#deskTabsToSelect'), $("#mobileTabsToSelect"));

          $('.blog #deskTabsToSelect a').on('click', function(){
              var href = $(this).attr('href');
              window.location = href;
          });


          $('.partnership #deskTabsToSelect a').on('click', function(){
              var href = $(this).attr('href');
              window.location = href;
          });
      }






      /*$('#deskTabsToSelect').on('change.zf.tabs', function(event, el){
          var $el = $(el).find('a');
          var target = $el.attr('data-tabs-target');
          _GD.realtyTypesSelect.val(target).trigger('change');
      });

      if(!_GD.realtyTypes){

          _GD.realtyTypes = [
              // {
              //     id: -1,
              //     text: '',
              //     selected: 'selected',
              //     search:'',
              //     hidden:true
              // }
          ];
          $('#deskTabsToSelect .tabs-title a').each(function(i,el) {
              var $el = $(el);
              _GD.realtyTypes.push({'id': $el.attr('data-tabs-target'),'text':$el.text()});
          });

           $("#mobileTabsToSelect").append($('<select name="realtyType" />'));
           _GD.realtyTypesSelect =  $("#mobileTabsToSelect select");

           if ( _GD.realtyTypesSelect.length ) {
               _GD.realtyTypesSelect.select2({
                   // placeholder: {
                   //     id: "-1",
                   //     text: "Выберите тип недвижимости",
                   //     selected:'selected'
                   // },
                   // allowClear:true,
                   data: _GD.realtyTypes,
                   theme: "dkt",
                   width: "100%",
                   minimumResultsForSearch: -1
               });
           }
          _GD.realtyTypesSelect.on('select2:select', function (e) {
              var data = e.params.data;
              var $target = $('#'+data.id);
              var historyHandled = false;
              if ($target.length) {
                  $('#deskTabsToSelect').foundation('selectTab', $target, historyHandled);
              } else {
                  var href = $('#deskTabsToSelect .tabs-title a[data-tabs-target='+data.id+']').attr('href');
                  window.location = href;
              }
          });
      }*/






});
var _GD = _GD||{};

$(document).ready(function() {
  if ($('.share').length) {
    $('.share').foundation('_setup', $('.share'), {
      tipText: $('#shareLinks').clone(true)
    });
    $('#shareLinks a').on('click', function (e) {
      // alert(this.className)
      e.preventDefault();
      _GD.shareService[this.className](window.location.href);
    });
  }
});

_GD.shareService = (function () {

  var params = {
    width: 600,
    height: 500
  };

  var openPopup = function (params) {
    var left = Math.round(screen.width / 2 - params.width / 2);
    var top = 0;
    if (screen.height > params.height) {
      top = Math.round(screen.height / 3 - params.height / 2);
    }

    var win = window.open(params.url, 'sl_' + params.service, 'left=' + left + ',top=' + top + ',' +
      'width=' + params.width + ',height=' + params.height + ',personalbar=0,toolbar=0,scrollbars=1,resizable=1');
    if (win) {
      win.focus();
    } else {
      location.href = params.url;
    }
  };

  var prepareUrl = function (url) {
    return url.replace(/([^:]\/)\/+/g, "$1");
  }

  var prepareTitle = function (str) {
    // Add colon to improve readability
    if (!/[.?:\-–—]\s*$/.test(str)) {
      return str += ':';
    }
    return str;
  }

  // var getCountValue = function(response, share) {
  //     var count = ($.isFunction(share.getCount) ? share.getCount(response) : response) || 0;
  //     return (typeof count === "string") ? count : this._formatNumber(count);
  // }

  var loadCount = function (countUrl, cb) {
    var deferred = $.Deferred();
    // var countUrl = this._getCountUrl(share);

    if (!countUrl) {
      return deferred.resolve(0).promise();
    }

    var handleSuccess = $.proxy(function (response) {
      // console.log("response", response);
      deferred.resolve(cb(response));
    }, this);

    $.getJSON(countUrl).done(handleSuccess)
      .fail(function () {
        console.log("getJSON fail", countUrl);
        $.get(countUrl).done(handleSuccess)
          .fail(function () {
            console.log("get fail", countUrl);
            deferred.resolve(0);
          });
      });

    return deferred.promise();
  }

  return {
    count: {
      _vk: function (url) {
        countUrl = 'https://vk.com/share.php?act=count&index=1&url=' + prepareUrl(url) + '&format=json&callback=?';
        var getCount = function (data) {
          // return parseInt(data.slice(15, -2).split(', ')[1]);
          return data.match(/^VK\.Share\.count\(\d, (\d+)\);$/)[1] / 1;
        }
        return loadCount(countUrl, getCount);
      },

      vk: function (url) {
        countUrl = 'https://vk.com/share.php?act=count&index=1&url=' + prepareUrl(url) + '&format=json&callback=?';
        var getCount = function (data) {
          // return parseInt(data.slice(15, -2).split(', ')[1]);
          // console.log("service vk data", data);
          return data.match(/^VK\.Share\.count\(\d, (\d+)\);$/)[1] / 1;
        }
        return loadCount(countUrl, getCount).done($.proxy(function (count) {
          // if(count) {
          // console.log("service vk count", count);
          return count;
          // }
        }, this));
      },

      tw: function (url) {
        // countUrl = "http://cdn.api.twitter.com/1/urls/count.json?url=" + prepareUrl(url) + "&callback=?";
        countUrl = "http://opensharecount.com/count.json?url=" + prepareUrl(url);
        var getCount = function (data) {
          return parseInt(data.count);
        }
        return loadCount(countUrl, getCount);

      },

      fb: function (url) {
        countUrl = "http://graph.facebook.com/?id=" + prepareUrl(url);
        var getCount = function (data) { //data.shares
          // console.log("service FB data", data);
          return data.share && data.share.share_count || 0;
        }
        return loadCount(countUrl, getCount).done($.proxy(function (count) {
          if (count) {
            return count;
          }
        }, this));
      },

      ok: function (url) {
        // countUrl = "http://www.odnoklassniki.ru/dk?st.cmd=shareData&ref=" + prepareUrl(url) + "&cb=mailru.share.ok.init";
        countUrl = "https://connect.ok.ru/dk?st.cmd=extLike&uid=odklcnt0&ref=" + prepareUrl(url) + "";
        var getCount = function (data) { //data.shares
          console.log("service ok data", data);
          // return parseInt(data.slice(15, -2).split(', ')[1]);
          return data.match(/^ODKL\.updateCount\(\'odklcnt0\',\'(\d+)\'\);$/)[1] / 1;
        }
        return loadCount(countUrl, getCount).done($.proxy(function (count) {
          // if(count) {
          console.log("service ok count", count);
          return count;
          // }
        }, this));
      }

    },
    buttons: function () {
      var services = ['wa', 'vk', 'ok', 'fb', 'tw'];
      return services;
    },
    wa: function (url) {
      params.service = 'wa';
      // params.url = 'https://api.whatsapp.com/send?text='+prepareUrl(url) + ' : '+prepareTitle(title);
      // whatsapp://send?text=
      params.url = 'https://api.whatsapp.com/send?text=' + prepareUrl(url);
      return openPopup(params);
    },
    fb: function (url) {
      params.service = 'fb';
      params.url = 'https://www.facebook.com/sharer/sharer.php?u=' + prepareUrl(url);
      return openPopup(params);
    },
    vk: function (url) {
      params.service = 'vk';
      params.url = 'https://vk.com/share.php?url=' + prepareUrl(url);
      return openPopup(params);
    },
    ok: function (url) {
      params.service = 'ok';
      params.url = 'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&service=odnoklassniki&st.shareUrl=' + prepareUrl(url);
      return openPopup(params);
    },
    mail: function (url) {
      params.service = 'mail';
      params.url = 'https://connect.mail.ru/share?share_url=' + prepareUrl(url);
      return openPopup(params);
    },
    tw: function (url, title) {
      params.service = 'tw';
      if (!title) {
        if ($) {
          title = $('meta[name="twitter:title"]').attr('content');
        } else {
          title = '';
        }
      }
      // params.url = 'https://twitter.com/intent/tweet?url='+prepareUrl(url);
      params.url = 'https://twitter.com/intent/tweet?url=' + prepareUrl(url) + '&text=' + prepareTitle(title);
      return openPopup(params);
    }
  }

})();
$(document).ready(function() {

    if ($('.mortgage .results').length) {
    
        // смена кадров для результата калькулятора
        $('.mortgage .results').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: 0,
            rows: 0,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            infinite: false
        });
    
    
    
        // форматирование цены для foundation slider => 1 000 000
        _GD.autoNum('price');
        _GD.autoNum('initial');
        _GD.autoNum('amount');
    
        _GD.initialPercentage  = 0.4;
        // первоначальный взнос
        // при изменении взноса высчитываем % к стоимости и далее при изменении стоимости учитываем в этой пропорции
        _GD.initialData = {
                "initialStart" : 100000,
                "start"        : 50000,
                "end"          : 1000000,
                "step"         : 50000
            };
    
        var $price             = $('#price');
        var $initial           = $('#initial');
        var $amount            = $('#amount');
        var $mortgageCalculate = $('.mortgage .calculate a');
        var $loader            = $mortgageCalculate.siblings('.for__loader');
        var $initialslider     = $initial.siblings('.slider');
        var $amountNum         = $('#amountNum');
            $amountNum.attr('readonly', true);
    
        // не отображаю - первоначальный взнос в процентах
            $initial.after('<span id="initialPercentage"></span>');
        var $initialPercentage = $('#initialPercentage');
            $initialPercentage.css({
                'position': 'relative',
                'width': '45px',
                'overflow': 'hidden',
                'display': 'none',
                'height': '40px',
                'margin-left': '-50px',
            });
        // \\
    
        // изменение данных слайдера без _destroy
        // TODO: уточнить перерисовку в фильтре каталога недвижимости
        _GD.rebuildSlider = function(el, opts){
            // REINIT SLIDER
            el.foundation('_setup', el, opts);
            setTimeout(function () {
                el.foundation('_reflow');
            }, 0);
        };
    
    
        _GD.buildBanksSelect = function() {
            var $select = $('#salarySelect');
            var source = '{{#each .}}<option value="{{this.title}}">{{this.title}}</option>{{/each}}';
            var template = Handlebars.compile(source);
            $select.append(template(_GD.banks));
        }
    
        // BINDS
        // рассчет суммы кредита
        $(document).on('input', '#priceNum, #initialNum', function(e) {
    
            var price   = $price .val();
            var initial = $initial.val();
            var amount  = price - initial;
    
            $amount.val(amount).trigger('change').trigger('input');
            $amountNum.val(amount).trigger('change').trigger('input');
            // $('#amountNum').val(amount);
            // $amount.mask("# ##0", {reverse: true});
            // $initialPercentage.html(Math.round(initial*100/price)+'%');
            $initialPercentage.html(Math.round(initial*100/price)+'%'); // не отображаю
        });
    
        $(document).on('input', '#priceNum',function(e) {
            var end = $price.val();
                _GD.initialData.end = end - _GD.initialData.start;
                _GD.initialData.initialStart = end * _GD.initialPercentage;
                _GD.rebuildSlider($initialslider, _GD.initialData);
        });
    
        $(document).on('input', '#initialNum',function(e) {
            _GD.initialPercentage = parseInt($initialPercentage.text().replace('%',''))/100;
        });
    
        // force serialize form data
        $mortgageCalculate.on('mousedown', function(e){
            $('#mortgageForm input').trigger('blur');
        });
    
    
        function _alasql(){
            return $.ajax({
                    url: 'https://cdn.jsdelivr.net/npm/alasql@0.4.3/dist/alasql.min.js',
                    type: 'GET',
                    dataType: 'script'
                });
        }
    
        function property(){
           return $.ajax({
                   url: '/json/taxonomy?q=property',
                   type: 'GET',
                   dataType: 'json'
               });
        }
    
        function banks(){
           return $.ajax({
                   url: '/json/banks?page[size]=500',
                   type: 'GET',
                   dataType: 'json'
               });
        }
    
        // в фоновом режиме получим названия банков, slug для типов недвижимости и алюскл
        $.when( property(), banks(), _alasql() )
           .then(function(_property, _banks, _alasql){
    
                // перевертыщ типа недвижимости (в шаблоне имя по-русски в базе slug)
                _GD.property = swap(_property[0].data.options);
                console.log("_GD.property", _GD.property);
    
                var res = alasql(
                    'SEARCH / AS @node RETURN(@node->id AS id, @node->attributes->title AS title) FROM ?',
                    [_banks[0].data]
                );
                _GD.banks = res;
                console.log("_GD.banks", _GD.banks);
                _GD.buildBanksSelect();
           })
           .fail(function(){
            //   console.log( 'I fire if one or more requests failed.' );
        });
    
    
    /*
        ######  ##       ####  ######  ##    ##
       ##    ## ##        ##  ##    ## ##   ##
       ##       ##        ##  ##       ##  ##
       ##       ##        ##  ##       #####
       ##       ##        ##  ##       ##  ##
       ##    ## ##        ##  ##    ## ##   ##
        ######  ######## ####  ######  ##    ##
    */
        // главное действие РАССЧИТАТЬ
        $mortgageCalculate.on('click', function(e){
            e.preventDefault();
            // ромашка на кнопку
            $loader.addClass('loader');
    
            _GD.mortgage        = []; // очищаем массив программ
            _GD.relTypeFiltered = [];
            _GD.formDataMapped  = {};
    
    
            setTimeout(function () { // вероятно таймаут нужен, что бы успели произойти калькуляции сумм и взносов
    
                var formData = _GD.formData = $.unserialize($('#mortgageForm').serialize());
    
    
                // данные формы
                    // amount "1800000"
                    // experience "3 мес"
                    // income "НДФЛ-2"
                    // initial "1200000"
                    // price "3000000"
                    // relType "Готовое жилье"
                    // salary "Сбербанк"
                    // social "Молодая семья"
                    // term "10"
    
                _GD.formDataMapping = {
                    'amount': "Сумма кредита",
                    'experience': "Стаж на последнем месте работы",
                    'income': "Способ подтверждения дохода",
                    'initial': "Первоначальный взнос",
                    'price': "Стоимость недвижимости",
                    'relType': "Тип недвижимости",
                    'salary': "Зарплатный проект",
                    'social': "Социальная программа",
                    'term': "Срок, лет",
                }
                $.each(_GD.formData, function(index, el) {
                    var _el = el;
                    if (index == "amount" || index == "initial" || index == "price"){
                        _el = parseInt(el).toLocaleString('ru-RU', {style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0}) + " руб.";
                    }
    
                    // normilize selected option value
                    if (index == "experience" || index == "income" || index == "social"){
                        if (el != 'Не выбрано…') { // HACK: HARDCODE Не выбрано…
                            _el = $('select[name="'+index+'"] option[value="'+el+'"]').text();
                            _GD.formDataMapped[_GD.formDataMapping[index]] = _el ;
                        }
                    }
    
                    if (el != 'Не выбрано…') { // HACK: HARDCODE Не выбрано…
                        _GD.formDataMapped[_GD.formDataMapping[index]] = _el ;
                    }
    
                });
    
    
                // шаг 1 - первоначальный филльтр JSON API response
                var filter = {
                    'filter':{
                        'amount_min' : '<=' + formData.amount,
                        'amount_max' : '>=' + formData.amount,
                        'term_min'   : '<=' + formData.term,
                        'term_max'   : '>=' + formData.term
                    }
                }
    
                // необязательный доп параметр стаж
                if (formData.experience!='Не выбрано…') { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                    filter.filter.experience = '<=' + formData.experience
                }
    
                // ненужные атрибуты их мы удалим впоследствии
                var toDel = [
                    'amount_max',
                    'amount_min',
                    'term_max',
                    'term_min',
    
                    'datechanged',
                    'datecreated',
                    'datedepublish',
                    'datepublish',
                    'incomingrelation',
                    'link',
                    'ownerid',
                    'rates',
                    'templatefields',
                    'status',
                    'username'
                ];
    
    
                // запрос с фильтром к JSON API for contnttype mortgage
                $.ajax({
                        url: '/json/mortgage?page[size]=500&' + $.param(filter),
                        type: 'GET',
                        dataType: 'json'
                    }).done(function(response) {
    
                        console.log("mortgage", response);
    
    console.time('relTypeFiltered'); // метка времени ради интереса
    
                        // пробежим по всем программам из JSON API
                        $.each(response.data, function(index, nested_programm) {
    
                            // ID в атрибуты
                            nested_programm.attributes.id = nested_programm.id;
    
                            // проименовываем банки
                            if (nested_programm.attributes.bank!='') {
                                var bankName = alasql(
                                    'SEARCH / AS @node WHERE(id="'+nested_programm.attributes.bank+'") FROM ?' ,
                                    [_GD.banks])[0];
                                if (bankName) { bankName = bankName.title } else { bankName = '' }
                                nested_programm.attributes.bank = bankName;
                            }
    
                            // каждая строка ставки из вложенного объекта программы в отдельный объект программы
                            $.each(nested_programm.attributes.rates, function(index, rate) {
    
                                // клонируем атрибуты, которые нас интересуют а именно ставки
                                var _attr = jQuery.extend({}, nested_programm.attributes); // clone object
    
                                $.each(rate, function(key, value) {
                                    _attr['rates_'+key] = (key == 'rate' || key == 'term_min') ? parseFloat(value) : value;
                                    // рассчет платежа
                                    if(key == 'rate'){
                                        var p = parseFloat(value)/1200; //переводим в доли за месяц
                                        var n = parseInt(formData.term) * 12;
                                        var S = parseInt(formData.amount);
                                        _attr.payment = (S * p / (1 - Math.pow(1 + p, -n))).toLocaleString('ru-RU', {style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0});
                                    }
                                });
    
                                // одновременно чистим лишние атрибуты
                                $.each(toDel, function(index, attr) {
                                    delete _attr[attr];
                                });
    
                                _GD.mortgage.push(_attr);
                            });
                        });
    
                        console.log("_GD.mortgage", _GD.mortgage);
    
                        // отсев по типу недвижки
                        // _GD.relTypeFiltered = alasql(
                        //     'SELECT * FROM ? WHERE "'+_GD.property[formData.relType]+'" IN property',
                        //     [_GD.mortgage]
                        // );
                        // по типу недвижимости перенесены в доп условия и ставки //
                        _GD.relTypeFiltered = _GD.mortgage;
    
                        console.log("relTypeFiltered", _GD.relTypeFiltered );
    
    console.timeEnd('relTypeFiltered');
    // https://ru.stackoverflow.com/questions/520048/%D0%9A%D0%B0%D0%BA-%D0%B8%D0%B7%D0%BC%D0%B5%D1%80%D0%B8%D1%82%D1%8C-%D0%B2%D1%80%D0%B5%D0%BC%D1%8F-%D0%B2%D1%8B%D0%BF%D0%BE%D0%BB%D0%BD%D0%B5%D0%BD%D0%B8%D1%8F-js-%D1%81%D0%BA%D1%80%D0%B8%D0%BF%D1%82%D0%B0-%D0%B2-%D0%BC%D0%B8%D0%BA%D1%80%D0%BE%D1%81%D0%B5%D0%BA%D1%83%D0%BD%D0%B4%D0%B0%D1%85-%D0%BD%D0%B5-%D0%B2-%D0%BC%D0%B8%D0%BB%D0%BB%D0%B8%D1%81%D0%B5%D0%BA%D1%83%D0%BD%D0%B4%D0%B0%D1%85
    
                        // отображение инфо на баннере
                        _GD.showResultsInfo( _GD.relTypeFiltered );
                    });
            }, 250); // не трогать!
        });
    
    
    Handlebars.registerHelper('declOfNum', function(context, block) {
          if (declOfNum) {
            var titles = block.hash.titles.split(',') || ['найдена', 'найдено', 'найдены'];
            return declOfNum(context, titles);
          }else{
            return context;
          }
        });
    
    
    /*
    
       ########  ########  ######     #### ##    ## ########  #######
       ##     ## ##       ##    ##     ##  ###   ## ##       ##     ##
       ##     ## ##       ##           ##  ####  ## ##       ##     ##
       ########  ######    ######      ##  ## ## ## ######   ##     ##
       ##   ##   ##             ##     ##  ##  #### ##       ##     ##
       ##    ##  ##       ##    ##     ##  ##   ### ##       ##     ##
       ##     ## ########  ######     #### ##    ## ##        #######
    
    */
    
    _GD.showResultsInfo = function (relTypeFiltered) {
    
        setTimeout(function () {
    
    console.time('showResultsInfo');
    
            $loader.removeClass('loader');
            // TODO: disable scroll if auto click orient bydaata-price
            if (!$('#mortgageForm').data('price')) {
                $('html, body').animate({
                    scrollTop: $("#mortgageResults").offset().top - $('header').height()
                }, 600);
            }
    
            // есть результат после первой фильтрации
            if (relTypeFiltered.length > 0) {
    
                // Проверка условий первоначального взноса
                _GD.initialFiltered = _GD.filterByInitial();
    
                // нет результатов после второй фильтрации
                if (_GD.initialFiltered.length < 1) {
    
                    _GD.showNoResults();
    
                } else {
    
                    // отсев ставок по доп параметрам
                    _GD.ratesFiltered = _GD.filterRates();
    
                    // совсем отсеяли
                    if (_GD.ratesFiltered.length < 1) {
    
                        _GD.showNoResults();
    
                    } else {
    
                        // и наконец то покажем результат
                        setTimeout(function () {
                            $('.mortgage .results').slick('slickGoTo', 1); // результаты есть переход на соотв. кадр
                        }, 250);
    
                        // объединим программы обрато по айди отсортировав по самой низшей ставке
                        var relTypeFilteredOrdered = alasql('SELECT * FROM ? GROUP BY id ORDER BY rates_rate ASC', [_GD.ratesFiltered]);
    
                        var countResults = {
                            'banksCount'    : alasql('SELECT count(bank) FROM ? GROUP BY bank', [relTypeFilteredOrdered]).length,
                            'programsCount' : alasql('SELECT count(id) FROM ? GROUP BY id', [relTypeFilteredOrdered]).length,
                            'payment'       : alasql('SELECT TOP 1 FROM ?',[relTypeFilteredOrdered])[0].payment
                        };
    
                        var source = '<span>Вам {{ declOfNum programsCount titles="подходит,подходят,подходит" }} <big class="fg-red">{{ programsCount }}</big> {{ declOfNum programsCount titles="программа,программы,программ" }}</span> ' +
                                    '<br> ' +
                                    '<span>по ипотеке в <big class="fg-red">{{ banksCount }}</big> {{ declOfNum banksCount titles="банке,банках,банках" }}</span>';
                        var template = Handlebars.compile(source);
                        $('#mortgageResults .result.is.found h2').html(template(countResults));
    
                            source = 'Ежемесячный платеж <span class="fg-red">от {{ payment }} руб.</span>';
                            template = Handlebars.compile(source);
                        $('#mortgageResults .result.is.found h2 + p').html(template(countResults));
    
                        // delete _GD.programsTableData; // очищаем шаблон вывода программ для мобильных
                        _GD.showResultsData(relTypeFilteredOrdered);
    
    console.timeEnd('showResultsInfo');
    
                    }
                }
            } else {
                _GD.showNoResults();
            }
    
        }, 200);
    };
    
    
    
    
    
    _GD.showNoResults = function() {
        setTimeout(function () {
            $('.mortgage .results').slick('slickGoTo', 2); // результатов нет переход на соотв. кадр
        }, 40);
        $('#results').hide();
    }
    
    
    
    
    /*
    
       ########    ########     ###    ######## ########  ######
       ##          ##     ##   ## ##      ##    ##       ##    ##
       ##          ##     ##  ##   ##     ##    ##       ##
       ######      ########  ##     ##    ##    ######    ######
       ##          ##   ##   #########    ##    ##             ##
       ##          ##    ##  ##     ##    ##    ##       ##    ##
       ##          ##     ## ##     ##    ##    ########  ######
    
    */
    _GD.filterRates = function () {
    
        var where              = '';
        var where_social       = '';
        var where_confirmation = '';
    
        // тип недвижимости
        var where_relType = 'WHERE "'+ _GD.property[decodeURIComponent(_GD.formData.relType)] +'" IN rates_property ';
    
        // Срок кредита
        var where_term = ' AND '+ _GD.formData.term +' >= rates_term_min ';
    
        // Соц. программа
        if (_GD.formData.social!='Не выбрано…') { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            where_social = ' AND "'+ _GD.formData.social +'" IN rates_social ';
        }
    
        // Сумма кредита (до/более)
        var where_amount =  ' AND (( rates_amount_less != "0" AND rates_amount_more = "0" AND '+ _GD.formData.amount +' <= rates_amount_less ) ' +
                        ' OR ( rates_amount_more != "0" AND rates_amount_less = "0" AND '+ _GD.formData.amount +' >= rates_amount_more ) '+
                        ' OR ( rates_amount_more = "0" AND rates_amount_less = "0" )) ';
    
        var amountPercentage   = Math.round(_GD.initialPercentage*100);
        console.log("filterRates amountPercentage", amountPercentage);
        // ПВ (от)
        var where_initial_min =  ' AND ('+ amountPercentage +' >= rates_initial_min  ' +
                        ' OR ( rates_initial_min = "0" OR rates_initial_min IS NULL )) ';
    
    
        // confirmation
        if (_GD.formData.income!='Не выбрано…') { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            where_confirmation = ' AND "'+ _GD.formData.income +'" IN rates_confirmation ';
        }
    
        // Зарплатный проект (Нивелирует confirmation и срок кредита?)
        if (_GD.formData.salary!='Не выбрано…') { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            where_confirmation = '';
            var where_initial = where_relType + where_term + where_social + where_amount + where_initial_min ;
            where = where_initial + ' AND ("'+ _GD.formData.salary +'" = bank AND rates_salary = "y" ) ';
            where += ' UNION ALL CORRESPONDING SELECT * FROM ? ' + where_initial + ' AND "'+ _GD.formData.salary +'" != bank ';
            where += ' UNION ALL CORRESPONDING SELECT * FROM ? ' + where_initial + ' AND ("'+ _GD.formData.salary +'" = bank AND (rates_salary="n" OR rates_salary IS NULL) )';
        } else {
            where = where_relType + where_term + where_social + where_amount  + where_initial_min + where_confirmation;
        }
    
    
        var ratesFiltered = alasql('SELECT * FROM ? '+ where, [_GD.initialFiltered, _GD.initialFiltered, _GD.initialFiltered]); // второй и третий массив нужен для UNION
        // alasql('SELECT * FROM ? WHERE "new" IN rates_property  AND ("ВТБ 24" = bank AND rates_salary = "1" ) UNION ALL CORRESPONDING  SELECT * FROM ? WHERE "new" IN rates_property AND "ВТБ 24" != bank', [_GD.initialFiltered,_GD.initialFiltered])
    
        console.log('SELECT * FROM ? '+ where);
        console.log("ratesFiltered", ratesFiltered);
    
        return ratesFiltered;
    
    }
    
    /*
       ########    #### ##    ## #### ########
       ##           ##  ###   ##  ##     ##
       ##           ##  ####  ##  ##     ##
       ######       ##  ## ## ##  ##     ##
       ##           ##  ##  ####  ##     ##
       ##           ##  ##   ###  ##     ##
       ##          #### ##    ## ####    ##
    */
    _GD.filterByInitial = function () {
    
        var amountPercentage   = Math.round(_GD.initialPercentage*100);
        console.log("amountPercentage", amountPercentage);
        var where_salary       = '';
        var where_social       = '';
        var where_confirmation = '';
    
        // тип недвижимости
        var where_relType = 'AND "'+ _GD.property[decodeURIComponent(_GD.formData.relType)] +'" IN property ';
    
        // confirmation
        if (_GD.formData.income!='Не выбрано…') { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            where_confirmation = ' AND "'+ _GD.formData.income +'" IN confirmation ';
        }
    
        // Соц. программа И. перекрывает зарплатный проект но включает подтверждение.
        if (_GD.formData.social!='Не выбрано…' /*&& _GD.formData.salary=='Не выбрано…'*/) { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            where_social = ' AND "'+ _GD.formData.social +'" IN social ';
    
            var sql = 'SEARCH DISTINCT(/ AS @node initial/ '+
                    'WHERE( '+ amountPercentage +' >= amount '+
                    where_relType +
                    where_social +
                    where_confirmation +
                ') @node) FROM ?'
            console.log("where_social", sql);
            var initialFiltered = alasql( sql, [_GD.relTypeFiltered]);
            console.log("initialFiltered", initialFiltered);
            return initialFiltered;
        }
    
    
        // Зарплатный проект (Нивелирует confirmation)
        if (_GD.formData.salary!='Не выбрано…') { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    
                where_salary = ' AND ("'+ _GD.formData.salary +'" = @node.bank AND salary = "y" ) ';
                // if (_GD.formData.social!='Не выбрано…'){
                //     where_social = ' AND "'+ _GD.formData.social +'" IN social ';
                // }
    
                var sql = 'SEARCH DISTINCT(/ AS @node initial/ '+
                        'WHERE( '+ amountPercentage +' >= amount '+
                        where_salary +
                        where_social +
                    ') @node) FROM ?'
                console.log("where_salary", sql);
                var initialFiltered = alasql( sql, [_GD.relTypeFiltered]);
                console.log("initialFiltered", initialFiltered);
                return initialFiltered;
            }
    
    
            // допы соц и зп не выбраны
            var sql = 'SEARCH DISTINCT(/ AS @node initial/ '+
                    'WHERE( '+ amountPercentage +' >= amount '+
                    where_relType +
                    where_confirmation +
                    'AND (salary="n" OR salary="" OR salary IS NULL)' +
                    'AND (social IS NULL OR social="" )' +
                ') @node) FROM ?'
            console.log("no where_salary no where_social", sql);
            var initialFiltered = alasql( sql, [_GD.relTypeFiltered]);
            console.log("initialFiltered", initialFiltered);
            return initialFiltered;
    
    }
    
    _GD.filterByInitial_BACK = function () {
    
            var amountPercentage = Math.round(_GD.initialPercentage*100);
            console.log("amountPercentage", amountPercentage);
            var where = '';
    
            // confirmation
            if (_GD.formData.income!='Не выбрано…') { // HACK: Не выбрано… !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
                where += ' AND "'+ _GD.formData.income +'" IN confirmation ';
            }
    
            var initialFiltered = alasql('SEARCH DISTINCT(/ AS @node initial/ '+
                'WHERE( '+ amountPercentage +' >= amount '+
                where +
                ' AND "'+ _GD.property[decodeURIComponent(_GD.formData.relType)] +'" IN property '+ // присутствует в любом случае
            ') @node) FROM ?', [_GD.relTypeFiltered]);
    
            // console.log("_GD.property[formData.relType]", _GD.property[decodeURIComponent(_GD.formData.relType)]);
            console.log("initialFiltered", initialFiltered);
            console.log('SEARCH DISTINCT(/ AS @node initial/ '+
                'WHERE( '+ amountPercentage +' >= amount '+
                where +
                ' AND "'+ _GD.property[decodeURIComponent(_GD.formData.relType)] +'" IN property '+
            ') @node) FROM ?');
    
            return initialFiltered;
    }
    
    
    
    /*
       ########  ########  ######     ########     ###    ########    ###
       ##     ## ##       ##    ##    ##     ##   ## ##      ##      ## ##
       ##     ## ##       ##          ##     ##  ##   ##     ##     ##   ##
       ########  ######    ######     ##     ## ##     ##    ##    ##     ##
       ##   ##   ##             ##    ##     ## #########    ##    #########
       ##    ##  ##       ##    ##    ##     ## ##     ##    ##    ##     ##
       ##     ## ########  ######     ########  ##     ##    ##    ##     ##
    */
    
    _GD.showResultsData = function (dataForTemplates) {
    
        var source = '{{#each .}}<tr class="result__line">' +
                        '<td>' +
                            '<label class="checkbox" for="mchk{{@key}}"> ' +
                                '<input type="checkbox" name="program[{{@key}}]" value="{{this.title}} (банк: {{this.bank}}, ставка: {{ this.rates_rate }}%, еж-мес. платеж: {{ this.payment }} руб.)" id="mchk{{@key}}" rel="{{this.bank}}"> ' +
                                '<i><svg class="svg"><use xlink:href="#icon-confirm"></use></svg></i>' +
                                '<b>{{this.bank}}</b>' +
                            '</label>' +
                        '</td>' +
                        '<td>{{this.title}}</td>' +
                        '<td>{{this.rates_rate}}%</td>' + //////////////////////// RATE
                        '<td>{{ this.payment }} руб.</td>' + // TODO:  ПЛАТЕЖ
                    '</tr>{{/each}}' ;
        var template = Handlebars.compile(source);
        $('#deskPrograms tbody').html(template(dataForTemplates));
    
    
        // for mobilePrograms
    
        // _GD.programsTableData = $('#deskPrograms').tableToJSON({
        //     extractor : function(cellIndex, $cell) {
        //         return $cell.find('b').text() || $cell.text();
        //     }
        // });
        // console.log(_GD.programsTableData);
        // console.log(JSON.stringify(table));
    
        var source =    '{{#each .}}<div class="grid-x result__line result__line_mob"> ' +
                            '<div class="cell header"> ' +
                                '<label class="checkbox" for="mchk{{ @key }}_mob"> ' +
                                    '<input type="checkbox" name="program[{{ @key }}]" value="{{ this.title }} (банк: {{this.bank}}, ставка: {{ this.rates_rate }}%, еж-мес. платеж: {{ this.payment }} руб.)" id="mchk{{ @key }}_mob" rel="{{this.bank}}"> ' +
                                    '<i><svg class="svg"><use xlink:href="#icon-confirm"></use></svg></i> ' +
                                    '{{ this.bank }}. {{ this.title }} ' +
                                '</label> ' +
                            '</div> ' +
                            '<div class="cell data"> ' +
                                '<div class="grid-x"> ' +
                                    '<div class="cell small-8 medium-6">процентная ставка</div> ' +
                                    '<div class="cell small-4 medium-6">{{ this.rates_rate }}%</div> ' + //////////////////////// RATE
                                '</div> ' +
                                '<div class="grid-x"> ' +
                                    '<div class="cell small-8 medium-6">ежемесячный платеж</div> ' +
                                    '<div class="cell small-4 medium-6">{{ this.payment }} руб.</div> ' +   // TODO:  ПЛАТЕЖ
                                '</div> ' +
                            '</div> ' +
                        '</div>{{/each}}';
    
        var template = Handlebars.compile(source);
        $('#mobilePrograms').html(template(dataForTemplates));
    
        setTimeout(function () {
            _GD.svgtoPath();
        }, 10);
    
    }
    // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    $('#results').hide();
    
    
        $(document).on('mousedown', '#deskPrograms tr td', function(e) {
            e.stopImmediatePropagation();
            if (!e.isTrigger) {
                if (!$(e.target).parents('label').length) {
                    $(e.target).parents('.result__line').find('label').trigger('click');
                }
            }
        });
    
    
    /*
    ########  ########     ########  #######     ########  #######  ########  ##     ##
    ##     ## ##     ##       ##    ##     ##    ##       ##     ## ##     ## ###   ###
    ##     ## ##     ##       ##    ##     ##    ##       ##     ## ##     ## #### ####
    ########  ########        ##    ##     ##    ######   ##     ## ########  ## ### ##
    ##        ##   ##         ##    ##     ##    ##       ##     ## ##   ##   ##     ##
    ##        ##    ##        ##    ##     ##    ##       ##     ## ##    ##  ##     ##
    ##        ##     ##       ##     #######     ##        #######  ##     ## ##     ##
    */
    
    
        $(document).on('change', '#deskPrograms input, #mobilePrograms input', function() {
            $('input[name="mortgage[program]"]').val(_GD.collectChcks());
            $('input[name="mortgage[banks]"]').val(_GD.collectBankChcks());
            // seed mortgage data
            // console.log("__formData", _GD.formDataMapped);
            // console.log(
            //         "formData",
            //         JSON.stringify(_GD.formDataMapped, null, ' ').replace(/[{"}]/g,'')
            //     );
            var formData = JSON.stringify(_GD.formDataMapped, null, ' ').replace(/[{"}]/g,'');
            console.log("formDataMapped", _GD.formDataMapped);
            console.log("formData", formData);
            $('input[name="mortgage[parameters]"]').val(formData);
            console.log("collectChcks", _GD.collectChcks());
            console.log("collectBankChcks", _GD.collectBankChcks());
        });
    
    
        _GD.collectChcks = function() {
            var programs = [];
            $('#deskPrograms input:checked, #mobilePrograms input:checked').each(function(index, el) {
                programs.push($(el).val());
            });
            // return "\n\r" + programs.join(";\n\r");
            return "\n\r" + programs.join(";\n");
        }
    
        _GD.collectBankChcks = function() {
            var banks = [];
            $('#deskPrograms input:checked, #mobilePrograms input:checked').each(function(index, el) {
                banks.push($(el).attr('rel'));
            });
            return "'" + banks.join("','") + "'";
        }
    
    
    
        // $(window).on('resize', function() {
            // if (!Foundation.MediaQuery.atLeast('large')) {
            // }
        // }).resize();
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    }
    
    });
    
    
    
    function swap(json){
      var ret = {};
      for(var key in json){
        ret[json[key]] = key;
      }
      return ret;
    }
    
    
    (function($){
        $.unserialize = function(serializedString){
            var str = decodeURI(serializedString);
            var pairs = str.split('&');
            var obj = {}, p, idx, val;
            for (var i=0, n=pairs.length; i < n; i++) {
                p = pairs[i].split('=');
                idx = p[0];
    
                if (idx.indexOf("[]") == (idx.length - 2)) {
                    // Eh um vetor
                    var ind = idx.substring(0, idx.length-2)
                    if (obj[ind] === undefined) {
                        obj[ind] = [];
                    }
                    obj[ind].push(p[1]);
                }
                else {
                    obj[idx] = p[1];
                }
            }
            return obj;
        };
    })(jQuery);
    
    /*
    
    ########  ##       ##     ## ########     ###    ##
    ##     ## ##       ##     ## ##     ##   ## ##   ##
    ##     ## ##       ##     ## ##     ##  ##   ##  ##
    ########  ##       ##     ## ########  ##     ## ##
    ##        ##       ##     ## ##   ##   ######### ##
    ##        ##       ##     ## ##    ##  ##     ## ##
    ##        ########  #######  ##     ## ##     ## ########
    
    */
    function declOfNum(number, titles) {
        var cases = [2, 0, 1, 1, 1, 2];
        return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    }
VK = {};
ODKL = {};

$(document).ready(function() {


    if($('.blog_share').length){
        var $share = $('.blog_share');
        var url = $share.attr('rel');
        // var url = 'http://news.ngs.ru/articles/52664531/';
        var _fb = _GD.shareService.count.fb(url).done($.proxy(function(count) {
           if(count) {
               // console.log("____count", count);
               $share.find('.fb').find('i').text(count);
           }
       }, this));


       VK.Share = {};
       VK.Share.count = function(index, count){
           console.log("obj VK ____count", count);
         $share.find('.vk').find('i').text(count);
       };
       var _vk = _GD.shareService.count.vk(url).done($.proxy(function(count) {
       // var _vk = _GD.shareService.count.vk('https://vk.com').done($.proxy(function(count) {
          // if(count) {
              // console.log("VK ____count", count);
              // $share.find('.vk').find('i').text(count);
          // }
      }, this));


      // ODKL.updateCount('odklcnt0','1');

      ODKL.updateCount = function(index, count){
          console.log("obj ODKL ____count", count);
        $share.find('.ok').find('i').text(count);
      };
       var _ok = _GD.shareService.count.ok(url).done($.proxy(function(count) {
       // var _ok = _GD.shareService.count.ok('https://ok.ru').done($.proxy(function(count) {
          // if(count) {
              // console.log("oK ____count", count);
              // $share.find('.ok').find('i').text(count);
          // }
      }, this));



        //   parse: function( res ) {
        //     return res.match( /^VK\.Share\.count\(\d, (\d+)\);$/ )[ 1 ] / 1;
        // }

        // http://twitcount.com/
          // https://github.com/clexit/social-widgets/blob/master/count-shares/javascript%20(nodejs)/count-shares/libs/networks.js
          // ODKL.updateCount('odklcnt0','1');
        //   parse: function( res ) {
        //     return res.match( /^ODKL\.updateCount\(\'odklcnt0\',\'(\d+)\'\);$/ )[ 1 ] / 1;
        // }
/*
                  var _ok = _GD.shareService.count['ok']('http://news.ngs.ru/articles/52664531/').done($.proxy(function(count) {
                     // if(count) {
                         console.log("____count ok", count);
                     // }
                 }, this));




                  // var _vk = _GD.shareService.count['vk']('http://js-socials.com/');
                  // console.log("vk", _vk)

                  var _vk = _GD.shareService.count['vk']('http://js-socials.com/').done($.proxy(function(count) {
                     // if(count) {
                         console.log("____count_vk", count);
                     // }
                 }, this));
// http://twitcount.com/
                  var _tw = _GD.shareService.count['tw']('http://js-socials.com/').done($.proxy(function(count) {
                     // if(count) {
                         console.log("____count_tw", count);
                     // }
                 }, this));
*/

    }

    if ($('.blog__list .__scroll').length) {

        // http://raphamorim.io/waterfall.js/
        // var grid = $('.blog__list .__scroll')[0];
        // waterfall(grid);

        // window.addEventListener('resize', function () {
            // waterfall(grid);
        // });


        $('.blog__list').jscroll({
            autoTrigger: false,
            contentSelector: 'a',
            nextSelector: 'a.section__link',
            //loadingHtml: '<img src="../images/load.gif" alt="Loading" />'
            loadingHtml: '<div class="ac"><a class="section__link">Загрузка ...</a></div>',

            callback : function() {

        		var o = $('.jscroll-added a');
        		var _items = $('.jscroll-added').find('.b-item');
        		$('.__scroll').append(_items);
                // waterfall(grid);
                // window.dispatchEvent('resize');
        		// $('.jscroll-added a').unwrap();
            }
        });

    }



    if($('.blog-gallery-slick').length){

        $('.blog-gallery-slick').each(function(index, el) {

            var $gallery = $(el);
            var galleryslidesToShow = $gallery.attr('data-slide');
            // var $galleryNav = $('#galleryNav');

            $gallery.slick({
                // lazyLoad: 'ondemand',
                swipeToSlide: true,
                rows: 0,
                slidesToShow: galleryslidesToShow,
                slidesToScroll: 1,
                centerMode: true,
                arrows: !false,
                // appendArrows: $galleryNav,
                // prevArrow: '<a class="_slick-prev"></a>',
                // nextArrow: '<a class="_slick-next"></a>',
                centerPadding: '0',
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: true
                        }
                    },
                ]
            });



            $gallery.magnificPopup({
                delegate: 'a', // child items selector, by clicking on it popup will open
                type: 'image',
                // other options
                mainClass: 'mfp-zoom-in',
                tLoading: '',
                tError: '',
                removalDelay: 500, //delay removal by X to allow out-animation
                callbacks: {

                    imageLoadComplete: function() {
                        var self = this;
                        setTimeout(function() {
                            self.wrap.addClass('mfp-image-loaded');
                        }, 16);

                        // var h = $('.mfp-img').height();
                        // var _h = $('.mfp-figure').height();
                        // var _T = ( _h - h ) * 0.5 ;
                        //
                        // $('.mfp-bottom-bar').css({'bottom':_T+'px'});
                    }

                    ,close: function() {
                        this.wrap.removeClass('mfp-image-loaded');
                    }

                    ,markupParse: function(){
                        setTimeout(function(){

                            //Enable swiping...
                            // $(".mfp-img").swipe( {
                            // 	//Generic swipe handler for all directions
                            // 	swipe:function(event, direction, distance, duration, fingerCount) {
                            // 		///$(this).text("You swiped " + direction );
                            //
                            // 		if (direction == 'right'/* || direction == 'up'*/) {
                            // 		 $.magnificPopup.instance.prev(); // go to prev item
                            // 		}
                            // 		if (direction == 'left'/* || direction == 'down'*/) {
                            // 		 $.magnificPopup.instance.next(); // go to next item
                            // 		}
                            // 	},
                            // 	//Default is 75px, set to 0 for demo so any distance triggers swipe
                            // 	threshold:75
                            // });

                        },150);
                    }

                },

                closeBtnInside: !false,
                closeOnContentClick: true,
                midClick: true

                , gallery: {
                    enabled: true, // set to true to enable gallery

                    preload: [0,2], // read about this option in next Lazy-loading section

                    navigateByImgClick: true,

                    arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

                    tPrev: '<', // title for left button
                    tNext: '>', // title for right button
                    tCounter: '' // markup of counter
                }

                ,image: {
                    markup: '<div class="mfp-figure">'+
                    '<div class="mfp-close"></div>'+
                    '<div class="mfp-img"></div>'+
                    // '<div class="mfp-bottom-bar">'+
                    // '<div class="mfp-title"></div>'+
                    '</div>'+
                    '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
                }
            });
        });
    } // end if



});
$(document).ready(function() {

    if (/(iphone|ipod|ipad)/.test(window.navigator.userAgent.toLowerCase())) {
         $('body').addClass('ios');
    }


    // $('*[data-toggle]').each(function(idx, obj){
    //
    // 	var o = $(obj);
    // 	var targets = o.attr('data-toggle').split(' ');
    //
    // 	e.preventDefault();
    // });

    $('*[data-toggle]').on('click', function(e) {
        e.preventDefault();
    });

    if ($('#deskTabsRequest').length) {
        _GD.tabsToSelect($('#deskTabsRequest'), $("#mobileTabsRequest"));
    }


    _GD.grecaptchaKey = $('script[data-grecaptcha-key]').data('grecaptcha-key');

    _GD.grecaptchaReGenerate = function(_grecaptchaKey, $form, cb){
        try {
          grecaptcha.execute(_grecaptchaKey, {action: grecaptchaActionName.replace(/-/g,'_')}).then(function(token) { 
            
            $form.find('input[name="g-recaptcha-response"]').remove();
            $form.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '" />');
        
            if (typeof cb == 'function') {
              try {
                cb($form)
                // window.scrollTo(0, 0)
              } catch( e ){
                console.log( 'call cb ERROR.', e );
              }
            }
          })
        } catch( e ){
          console.log( 'Notice: Error trying to execute grecaptcha.', e );
        }
      }


/*
 ######  ##     ## ########  ##     ## #### ########
##    ## ##     ## ##     ## ###   ###  ##     ##
##       ##     ## ##     ## #### ####  ##     ##
 ######  ##     ## ########  ## ### ##  ##     ##
      ## ##     ## ##     ## ##     ##  ##     ##
##    ## ##     ## ##     ## ##     ##  ##     ##
 ######   #######  ########  ##     ## ####    ##
*/
    _GD.forms = [
        'form[name="request"]',
        'form[name="call_me"]',
        'form[name="appointment"]',
        'form[name="my_price"]',
        'form[name="subscribe_price"]',
        'form[name="subscribe_newin"]',
        'form[name="mortgage"]',
        'form[name="consult"]',
        'form[name="resume"]',
    ];

    _GD.formsPhones = [
        'input[name="call_me[phone]"]',
        'input[name="request[phone]"]',
        'input[name="appointment[phone]"]',
        'input[name="my_price[phone]"]',
        'input[name="subscribe_newin[phone]"]',
        'input[name="mortgage[phone]"]',
        'input[name="consult[phone]"]',
        'input[name="resume[phone]"]',
    ];


    _GD.formIsValid = false;
    _GD.formIsSubmitted = false;

    //    $('.form').on('submit', function(e){
    _GD.submitForm = function($form) {

        if (!_GD.formIsValid) return;
        if (_GD.formIsSubmitted) return;

        _GD.formIsSubmitted = true;

       // e.preventDefault();
        //        var form = $(this);

        var action = $form.attr('action');
        // var action = '/async/boltforms/submit?form=' + $form.attr('name');

        $form.find('.for__loader').addClass('loader');


        _GD.grecaptchaReGenerate(_GD.grecaptchaKey, $form, function($form){

            setTimeout(function() {
    
                $('#thnxClose').trigger('click');
                if (!$form.parents('section[data-toggler="outofscreen"]').hasClass('outofscreen')) {
                    $form.parents('.popup').find('.close').trigger('click');
                }
                $form.get(0).reset();
                $('button[type=reset]').trigger('click');
                $form.find('.for__loader').removeClass('loader');
                _GD.formIsSubmitted = false;
    
            }, 1500);

            
            // var data = $form.serialize();
            var data = new FormData($form[0]);
    
            $.ajax({
                    type: "POST",
                    url: action,
                    contentType: false,
                    processData: false,
                    data: data
                })
                .fail(function(data) {
                    console.log('fail', data);
                })
                .done(function(response) {
                    console.log('obj:' + action, response);
                    if (window.yaCounter11111650) {
                        yaCounter11111650.reachGoal('zakaz')
                    }
                });

            return;
        })

    }
    //    });




/*
########  ##     ##  #######  ##    ## ########
##     ## ##     ## ##     ## ###   ## ##
##     ## ##     ## ##     ## ####  ## ##
########  ######### ##     ## ## ## ## ######
##        ##     ## ##     ## ##  #### ##
##        ##     ## ##     ## ##   ### ##
##        ##     ##  #######  ##    ## ########
*/

    $(_GD.formsPhones.join(','))
        .attr('type','tel')
        .attr('autocomplete','off')
        .mask("+7 (000) 000-0000", {placeholder: "+7 (___) ___-____", clearIfNotMatch: true})
        .on('focus click', function() {
            var $phone = $(this);
            if ($phone.val().length === 0) {
                $phone.val('+7 (');
                setTimeout(function() {
                    $phone.setCursorPosition($phone.val().length);
                }, 10);
            }
        })
        .on('blur', function() {
            var $phone = $(this);
            if ($phone.val() === '+7 (') {
                $phone.val('');
            }
        })
    ;


    //SET CURSOR POSITION
    $.fn.setCursorPosition = function(pos) {
        this.each(function(index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };




/*
########  ######## ##    ##       ########  ####  ######     ###    ########  ##       ########
##     ##    ##    ###   ##       ##     ##  ##  ##    ##   ## ##   ##     ## ##       ##
##     ##    ##    ####  ##       ##     ##  ##  ##        ##   ##  ##     ## ##       ##
########     ##    ## ## ##       ##     ##  ##   ######  ##     ## ########  ##       ######
##     ##    ##    ##  ####       ##     ##  ##        ## ######### ##     ## ##       ##
##     ##    ##    ##   ###       ##     ##  ##  ##    ## ##     ## ##     ## ##       ##
########     ##    ##    ##       ########  ####  ######  ##     ## ########  ######## ########
*/
    _GD.onDisabled = function(form) {
        $.each(form, function(i, _form) {
            var submit = $(_form).find('*[type=submit]');
            if (submit.hasClass('disabled')) {
                return;
            } else {
                submit.addClass('disabled');
                // submit.attr('disabled','disabled').addClass('disabled');
            }
        });
    };
    _GD.offDisabled = function(form) {
        $.each(form, function(i, _form) {
            var submit = $(_form).find('*[type=submit]');
            if (!submit.hasClass('disabled')) {
                return;
            }else{
                submit.removeClass('disabled');
                // submit.removeAttr('disabled').removeClass('disabled');
            }
        });
    };

    // https://www.sitepoint.com/10-jquery-form-validation-plugins/
    // http://parsleyjs.org/doc/index.html#events


    $.each($(_GD.forms.join(',')), function(i, _form) {

        $(_form).parsley({
                uiEnabled: !false,
                trigger: 'keyup change blur input',
                validationThreshold: 1,
                errorClass: 'error',
                errorsWrapper: '<ul class="error-messages"></ul>'
            })
            .on('form:error', function(formInstance) {
                _GD.formIsValid = !true;
                //       console.log('error formInstance:', formInstance);
                return false;
            }).on('form:success', function(formInstance) {
                _GD.formIsValid = true;
                //       console.log('success formInstance:', formInstance);
                return false;
            }).on('form:submit', function(formInstance) {
                if (formInstance.isValid()) {
                    _GD.formIsValid = true;
                    _GD.submitForm(this.$element);
                }
                //       console.log('submit formInstance:', formInstance.isValid());
                return false;
            })
            .on('field:error', function() {
                //               console.log('Validation failed for: ', this.$element);
                if (!this.parent.isValid()) {
                    _GD.onDisabled(this.parent.$element);
                }
            })
            .on('field:success', function() {
                //              console.log('Validation success for: ', this.$element);
                if (this.parent.isValid()) {
                    _GD.offDisabled(this.parent.$element);
                }
            });

    });


    _GD.onDisabled($(_GD.forms.join(',')));

    // NOVALIDATE !!!

});


/*

      ####    ##    #######  ##    ##
       ##   ####   ##     ## ###   ##
       ##     ##   ##     ## ####  ##
       ##     ##    #######  ## ## ##
       ##     ##   ##     ## ##  ####
       ##     ##   ##     ## ##   ###
      ####  ######  #######  ##    ##

*/

// Validation errors messages for Parsley
// Load this after Parsley

Parsley.addMessages('ru', {
  defaultMessage: "Некорректное значение.",
  type: {
    email:        "Введите адрес электронной почты.",
    url:          "Введите URL адрес.",
    number:       "Введите число.",
    integer:      "Введите целое число.",
    digits:       "Введите только цифры.",
    alphanum:     "Введите буквенно-цифровое значение."
  },
  notblank:       "Это поле должно быть заполнено.",
  required:       "Обязательное поле.",
  pattern:        "Это значение некорректно.",
  min:            "Это значение должно быть не менее чем %s.",
  max:            "Это значение должно быть не более чем %s.",
  range:          "Это значение должно быть от %s до %s.",
  minlength:      "Это значение должно содержать не менее %s символов.",
  maxlength:      "Это значение должно содержать не более %s символов.",
  length:         "Это значение должно содержать от %s до %s символов.",
  mincheck:       "Выберите не менее %s значений.",
  maxcheck:       "Выберите не более %s значений.",
  check:          "Выберите от %s до %s значений.",
  equalto:        "Это значение должно совпадать."
});

Parsley.setLocale('ru');
$(document).ready(function() {



if($('.vacancy-gallery-slick').length){

    var $gallery = $('.vacancy-gallery-slick');
    // var $galleryNav = $('#galleryNav');

    $gallery.slick({
        // lazyLoad: 'ondemand',
        swipeToSlide: true,
        slidesToShow: 3,
        rows: 0,
        slidesToScroll: 1,
        centerMode: true,
        arrows: !false,
        // appendArrows: $galleryNav,
        // prevArrow: '<a class="_slick-prev"></a>',
        // nextArrow: '<a class="_slick-next"></a>',
        centerPadding: '0',
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true
                }
            },
    ]
});



$gallery.magnificPopup({
    delegate: 'a', // child items selector, by clicking on it popup will open
    type: 'image',
    // other options
    mainClass: 'mfp-zoom-in',
    tLoading: '',
    tError: '',
    removalDelay: 500, //delay removal by X to allow out-animation
    callbacks: {

        imageLoadComplete: function() {
            var self = this;
            setTimeout(function() {
                self.wrap.addClass('mfp-image-loaded');
            }, 16);

            // var h = $('.mfp-img').height();
            // var _h = $('.mfp-figure').height();
            // var _T = ( _h - h ) * 0.5 ;
            //
            // $('.mfp-bottom-bar').css({'bottom':_T+'px'});
        }

        ,close: function() {
            this.wrap.removeClass('mfp-image-loaded');
        }

        ,markupParse: function(){
            setTimeout(function(){

                //Enable swiping...
                // $(".mfp-img").swipe( {
                // 	//Generic swipe handler for all directions
                // 	swipe:function(event, direction, distance, duration, fingerCount) {
                // 		///$(this).text("You swiped " + direction );
                //
                // 		if (direction == 'right'/* || direction == 'up'*/) {
                // 		 $.magnificPopup.instance.prev(); // go to prev item
                // 		}
                // 		if (direction == 'left'/* || direction == 'down'*/) {
                // 		 $.magnificPopup.instance.next(); // go to next item
                // 		}
                // 	},
                // 	//Default is 75px, set to 0 for demo so any distance triggers swipe
                // 	threshold:75
                // });

            },150);
        }

    },

    closeBtnInside: !false,
    closeOnContentClick: true,
    midClick: true

    , gallery: {
        enabled: true, // set to true to enable gallery

        preload: [0,2], // read about this option in next Lazy-loading section

        navigateByImgClick: true,

        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

        tPrev: '<', // title for left button
        tNext: '>', // title for right button
        tCounter: '' // markup of counter
    }

    ,image: {
        markup: '<div class="mfp-figure">'+
        '<div class="mfp-close"></div>'+
        '<div class="mfp-img"></div>'+
        // '<div class="mfp-bottom-bar">'+
        // '<div class="mfp-title"></div>'+
        '</div>'+
        '</div>', // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
    }
});
}






    if ($('#resume_attach')) {

        $('form[name=resume]').on('reset', function(e){
            $('#resume_attach').removeClass('hide');
            $('#resume_send').addClass('hide');
        });

        $('#resume_upload').on('change', function(e){

            var resume = $(this)[0].files[0].name;
            $('#resume_upload_info span').text(resume);

            $('#resume_attach').addClass('hide');
            $('#resume_send').removeClass('hide');

            $('#resume_send .cancel').on('click', function() {
                $('#resume_attach').removeClass('hide');
                $('#resume_send').addClass('hide');
            });

            // var ext = $(this).val().match(/\.([^\.]+)$/)[1];
            // switch(ext)
            // {
            //     case 'jpg':
            //     case 'bmp':
            //     case 'png':
            //     case 'tif':
            //         alert('allowed');
            //         break;
            //     default:
            //         alert('not allowed');
            //         $(this).val('');
            // }
        });
        // _GD.uploadResume = $('#resume_upload').clone(true);
        // $('#resume_upload_info .change').append(_GD.uploadResume);
        $('#resume_upload_info .change').on('click', function (e) {
            e.preventDefault();
            $('#resume_upload').trigger('click');
        });
    }

});

$(document).ready(function() {



    if ($('.office .map').length) {

        $('.offices_section .tabs').on('change.zf.tabs', function(event, el){
            var $el = $(el).find('a');
            var target = $el.attr('data-tabs-target');
            // console.log("$el", $el);
            // console.log("target", target);
            var map = $('#office_'+target).data('map');
            map.invalidateSize();
        });

        // setTimeout(function () {
        //     $('.offices_section .tabs').foundation('_destroy');
        // }, 5000);
        //
        // setTimeout(function () {
        //     var elem = new Foundation.Tabs($('.offices_section .tabs'), {});
        //     console.log("elem", elem);
        // }, 10000);
        $('.office .map').on('on.zf.toggler', function (e, el) {
            // console.log("e", e);
            // console.log("el", el);
            var map = $(el).data('map');
            console.log("map", map);
            map.invalidateSize();
        });
        $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {


            if ( Foundation.MediaQuery.is('medium only') || Foundation.MediaQuery.is('small only') ) {
                // console.log("newSize", newSize);
                $('.tabs-panel').addClass('is-active');
                $('.office .map').foundation('toggle');

            } else {

            }

        }).trigger('changed.zf.mediaquery');

        DG.then(function () {

            $('.office .map').each(function(index, el) {
                var o = $(el);
                var id = o.attr('id');
                var lat = o.attr('data-lat');
                var lng = o.attr('data-lng');
                var _coords = [
                    parseFloat(lat),
                    parseFloat(lng)
                ]

                var Icon = DG.icon({
                    iconUrl: '/t/dk/i/icons/pin.svg',
                    // iconUrl: 'i/main/trinket.jpg',
                    // iconRetinaUrl: 'my-icon@2x.png',
                    iconSize: [50, 50],
                    iconAnchor: [25,50],
                    // popupAnchor: [-3, -76],
                    // shadowUrl: 'i/main/trinket.jpg',
                    // shadowRetinaUrl: 'my-icon-shadow@2x.png',
                    // shadowSize: [68, 95],
                    // shadowAnchor: [22, 94]
                });

                // var map = L.map('map').setView([55.17, 61.39], 16);
                // L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {}).addTo(map);

                var map = DG.map(id, {
                        center: [54.98, 82.89],
                        zoom: 17
                    });
                o.data('map', map);
                // DG.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {}).addTo(map);
                 // DG.tileLayer('https://vec{s}.maps.yandex.net/tiles?l=map&v=4.55.2&z={z}&x={x}&y={y}&scale=1&lang=ru_RU', {
                //     subdomains:['01','02','03']
                // }).addTo(map);

                DG.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
                    maxZoom: 19,
                    subdomains:['mt0','mt1','mt2','mt3']
                }).addTo(map);

                // DG.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{
                //     maxZoom: 20,
                //     // subdomains:['mt0','mt1','mt2','mt3']
                // }).addTo(map);

                setTimeout(function () {
                    DG.marker(_coords, {icon: Icon}).addTo(map);
                    map.panTo(_coords);
                }, 100);

                });

            });
    }


});